import React  from 'react';
//前言
import haiwaineimaocaigouliucheng from '../assets/img/haiwaineimaocaigouliucheng.png';
import fukuanliucheng from '../assets/img/fukuanliucheng.png';
import kaipiaoliucheng from '../assets/img/kaipiaoliucheng.png';
import shouhuifapiao from '../assets/img/shouhuifapiao.png';
import beiyongjin from '../assets/img/beiyongjin.png';
import baoxiaoliucheng from '../assets/img/baoxiaoliucheng.png';
import taizhangliucheng from '../assets/img/taizhangliucheng.png';
const Enclosure614 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>海外业务管理公司统计部业务流程细则</h3>
            <h3>（一）内贸采购流程</h3>
            <p>1.采购申请人按照与供应商达成一致的合同条款，逐条具体、如实、规范、完整填写采购合同。</p>
            <p>2.采购申请人将填写好的采购合同、项目审批表，交部门总监审核。</p>
            <p>3.部门总监核实无误后，与财务总监（傅总或者郝总）沟通，达成一致后，合同交于统计。</p>
            <p>4.统计提交采购合同找财务总监审核盖章。</p>
            <p>注：云湖春煜的采购找郝总确认，北京欧豪、北京綦齿的找傅总确认。</p>
            <p>云湖春煜的章找刘燕盖章，北京欧豪、北京綦齿的找图雅盖章。</p>
            <p>5.统计将盖章后的合同按照采购申请人的要求寄送给供应商。</p>
            <p>6.供应商收到合同后盖章回寄合同</p>
            <p>7.统计收到合同后，将盖章后的合同扫描存档，并邮件发送傅总、郝惠东总、范晓瑞总及采购负责人，最后将合同原件交到财务郝惠东总留档，复印件交到财务傅总留档。</p>
            <img src={haiwaineimaocaigouliucheng} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
            <h3>（二）付款流程</h3>
            <p>1.   用款人填写用款申请书，申请付款。</p>
            <p>2.   用款人将填写好的用款申请书，交部门总监审核。</p>
            <p>3.   明确财务是否明确项目用款</p>
            <p>3.1  傅总了解项目用款：部门总监核实无误后签字，签字后的用款申请书交于统计。</p>
            <p>3.2  傅总不了解项目用款：部门总监与集团财务傅总沟通后，没有问题，签字。</p>
            <hp>4.   统计将部门总监签字后的用款申请书交财务部门郝惠东总审核签字。</hp>
            <p>5.   统计将签字后的用款申请书扫描，发送至微信财务群，并说明情况吗，请求付款。原件留存。</p>
            <p>6.   付款后，财务提供付款水单，水单留存并发送收款人。</p>
            <img src={fukuanliucheng} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
            <h3>（三）开票流程</h3>
            <p>1.开票申请人和部门总监沟通开票事宜，无误后制作开票信息。</p>
            <p>2.开票申请人将制作好的开票信息，交部门总监审核。</p>
            <p>3.部门总监核实无误后和财务傅总、郝总沟通开票事宜。</p>
            <p>4.部门总监邮件将开票信息发送给财务傅总、郝总、统计。</p>
            <p>5.统计拿到财务开出的发票，确认无误后发送给开票申请日确认并扫描留存。</p>
            <p>6.统计按照开票申请人要求，将发票寄出，并将快递单号提交给开票申请人。</p>
            <img src={kaipiaoliucheng} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
            <h3>（四）回收发票流程</h3>
            <p>1.	统计收到发票后核实发票信息，无误后扫描留存，并发送给负责人。</p>
            <p>2.	登记发票信息。</p>
            <p>3.	发票递交财务郝总。</p>
            <img src={shouhuifapiao} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
            <h3>（五）备用金申请流程</h3>
            <p>1、用款人和部门总监申请备用金</p>
            <p>2、填写借款单，交部门总监</p>
            <p>3、申请备用金金额小于人民币1000元，部门总监确认后签字。</p>
            <p>申请备用金金额大于人民币1000元，部门总监和财务傅总沟通，无误后签字。</p>
            <p>4、签字后的借款单交于统计</p>
            <p>5、统计将借款单交于大兴基地1楼财务室图雅处。</p>
            <img src={beiyongjin} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/>
            <h3>（六）报销流程</h3>
            <p>1、用款人填写报销本，并整理发票</p>
            <p>2、整理好后，交于部门总监签字</p>
            <p>3、部门总监确认无误后签字</p>
            <p>4、用款人将报销本交于统计</p>
            <p>5、统计拿报销本</p>
            <p>1)金额小于1000元，统计直接将报销本交到财务图雅处。</p>
            <p>2)金额大于1000元，交于财务郝惠东总，签字</p>
            <p>6、签字后将报销本交于大兴基地1楼财务室图雅处。</p>
            <img src={baoxiaoliucheng} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
            <h3>（七）台账记录</h3>
            <p>1、台账类型：整车台账、上装台账、配件台账</p>
            <p>2、业务确认开展后，项目负责人首先找统计员拿到对应的采购合同号、外贸合同号及项目审批表号；</p>
            <p>3、项目负责人将相关单据发送给统计员，统计员按照项目负责人提供的数据更新台账；</p>
            <p>4、货物报关结束后，统计员将内、外贸拿到财务盖章（欧豪盖章均需傅总同意；云湖的盖章均需得到郝总同意，欧豪公章、合同章在图雅处；欧豪外贸章、云湖公章、合同章、外贸章；亚非外贸章均在刘燕处。）</p>
            <p>5、将盖过章的合同扫描留存，并发送给项目负责人；</p>
            <p>6、一个项目结束后，将对应的相关单据（包括：内、外贸合同；箱单；发票；采购发票；报关单；项目审批表及其他涉及到的情况说明）以邮件的形式发送，并微信通知给财务（傅总、郝总、刘晓霞、郭华兵）、海外部总经理</p>
            <img src={taizhangliucheng} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
            <h3>（八）应收应付账款整理</h3>
            <p>主要有：采购应付账款和销售应收账款</p>
            <p>确认采购后，整理应付账款</p>
            <p>确认销售后，整理应付账款</p>
        </div>
    </div>



export default Enclosure614;